export default __webpack_public_path__ + "static/media/location.e61e6f92.svg";